import { render, staticRenderFns } from "./compareFacilities.vue?vue&type=template&id=12b952d0&scoped=true"
import script from "./compareFacilities.vue?vue&type=script&lang=js"
export * from "./compareFacilities.vue?vue&type=script&lang=js"
import style0 from "./compareFacilities.vue?vue&type=style&index=0&id=12b952d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b952d0",
  null
  
)

export default component.exports